<template>
  <div class="redirect w-full bg-white min-h-screen">
    <h2 class="px-16 lg:px-32 py-8 redirect__heading text-4xl font-extrabold">
      Notice
    </h2>
    <div class="px-16 lg:px-32">
      <div class="redirect__description">
        <div
          class="redirect__description__content my-10"
          v-if="itemDetails.url"
        >
          <p class="break-words text-sm md:text-lg">
            The page you were on is trying to send you to
          </p>
          <div class="lg:w-4/5">
            <a
              :href="itemDetails.url"
              class="cursor-pointer underline text-blue-700 text-xs md:text-sm break-words"
            >
              {{ itemDetails.url }}
            </a>
          </div>
        </div>
        <!-- <div class="redirect__description__content lg:mt-8">
          <p class="text-sm md:text-lg">
            The below Video is suggested to you because your Skill/Behavior
            development priority is set with tags:
            <span class="tag flex items-center flex-wrap mt-3">
              <span
                class="tag__text text-xs font-semibold mr-2 mb-2"
                v-for="(tag, index) in itemDetails.tags"
                :key="index"
                >#{{ tag }}</span
              >
              &nbsp;
            </span>
          </p>
        </div> -->

        <div class="course__content mt-8 lg:mt-10 flex align-start">
          <div
            class="course-img relative flex items-center justify-center mb-4 md:mb-0"
          >
            <img
              class="w-full h-full object-cover rounded-lg"
              :src="
                itemDetails.imageUrl ? itemDetails.imageUrl : randomFeedImage
              "
              @error="randomFeedImage"
            />
            <div class="absolute flex items-center justify-center">
              <img
                v-if="itemDetails.format === 'WATCH'"
                class="img__logo"
                src="@/assets/images/redirect-page/play.svg"
                alt="WATCH"
              />
              <img
                v-else-if="itemDetails.format === 'LISTEN'"
                class="img__logo"
                :src="require(`@/assets/images/redirect-page/headphone.svg`)"
                alt="LISTEN"
              />
            </div>
          </div>
          <div class="details">
            <div class="details__title flex item-start items-center">
              <div class="h-8 w-8 overflow-none">
                <img
                  class="w-full h-full object-cover rounded-full"
                  :src="itemDetails.source ? itemDetails.source : 'GetBoarded'"
                  :alt="itemDetails.source ? itemDetails.source : 'GetBoarded'"
                  @error="altSrcImage"
                />
              </div>

              <p class="text-sm md:text-base font-semibold ml-2">
                {{ itemDetails.source }}
              </p>
              <!-- <p>{{ itemDetails.source }}</p> -->
            </div>
            <div class="details__heading flex items-start">
              <h4 class="clip-text font-bold text-lg md:text-2xl mr-3">
                {{ itemDetails.title }}
              </h4>
              <img
                class="details__logo cursor-pointer"
                src="@/assets/images/redirect-page/soft.svg"
              />
            </div>
            <div class="details__text text-justify clip-text clip-text-3">
              <p class="text-sm md:text-base">
                {{ itemDetails.description }}
              </p>
            </div>
          </div>
        </div>
        <!-- <div class="redirect__description__content lg:mt-10">
        <p class="text-xs md:text-lg">
          You can rate the relevance of the content suggestion and the content
          quality from the web page or the email you came for.
        </p>
        <p class="text-xs md:text-lg" v-if="count === 0">Redirecting...</p>
        <p class="text-xs md:text-lg mt-2 md:mt-3" v-else>
          This page will redirect itself in {{ count }} seconds.
        </p>
      </div> -->
      </div>

      <div
        v-if="validationCompleted"
        class="flex flex-col md:flex-row items-center justify-between rounded-lg shadow-lg my-6 py-4 px-8 md:my-16 md:py-6"
      >
        <div class="flex flex-col md:flex-row items-center lg:w-4/5">
          <img
            class="w-40 h-40 mr-2 lg:mr-6"
            src="@/assets/images/complete.svg"
            alt=""
          />
          <div
            class="md:text-left text-medium lg:text-xl my-4 md:my-0"
            style="color: #25cc9a"
          >
            The item has been validated.<br />
            Check notifications for any associated reward.
          </div>
        </div>
        <vs-button
          @click="$router.push('/user/notifications')"
          color="#25CC9A"
          class="font-2xl mr-4"
        >
        Validation Queue
        </vs-button>
      </div>

      <div
        v-if="isUserReallyAssigned"
        class="flex flex-col md:flex-row items-center justify-between rounded-lg shadow-lg my-6 py-4 px-8 md:my-16 md:py-6"
      >
        <div class="flex flex-col md:flex-row items-center lg:w-4/5">
          <img
            class="mr-2 lg:mr-6"
            src="@/assets/images/incomplete.svg"
            alt=""
          />
          <div
            class="text-left text-medium lg:text-xl my-4 md:my-0"
            style="color: #f04438"
          >
            This course is not in your development queue to be claimed.
            <br />
            If you feel this is an error, contact the organization admin.
          </div>
        </div>
        <vs-button color="#F04438" class="font-2xl"
          ><a href="mailto:altf.getboarded@gmail.com" class="text-white"
            >Contact
          </a>
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/constants";

export default {
  data() {
    return {
      constants,
      validationCompleted: false,
      isUserReallyAssigned: false,
      itemDetails: {},
      count: 5,
    };
  },
  created() {
    if (!this.authUserData) {
      window.location.href = `${constants.apiHost}/oauth`;
    }
  },
  mounted() {
    if (!this.authUserData) {
      window.location.href = `${constants.apiHost}/oauth`;
    } else {
      let { orgId, type, itemId, token } = this.$route.query;
      this.getLibraryItems(itemId, orgId, token, type);
    }
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    userData() {
      return this.$store.state.users.data;
    },
    authUserData() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    reverseTimeCounter() {
      setInterval(() => {
        this.count = this.count >= 1 ? this.count - 1 : 0;
      }, 1000);
    },
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    getLibraryItems(itemId, orgId, token, type) {
      const payload = {
        orgId: orgId,
        itemId: itemId,
        userId: this.authUserData._id,
      };
      this.$store
        .dispatch("alex/fetchCustomLibraryItem", payload)
        .then((res) => {
          if (res.data) {
            this.itemDetails = res.data;
            this.getAttendance(this.authUserData._id, orgId, itemId, token);
          } else {
            const payload = {
              itemId: itemId,
              userId: this.authUserData._id,
              type: type,
            };
            this.$store
              .dispatch("alex/fetchLibraryItemDetails", payload)
              .then((res) => {
                if (res) {
                  this.itemDetails = res;
                  this.getAttendance(
                    this.authUserData._id,
                    orgId,
                    itemId,
                    token
                  );
                }
              })
              .catch((err) => {});
          }
        })
        .catch((err) => {});
    },
    getAttendance(userId, orgId, itemId, token) {
      this.$store
        .dispatch("users/getAttendance", {
          organizationId: orgId,
          feedItemId: itemId,
          userId: userId,
        })
        .then((res) => {
          if (
            (res && res.data && res.data.eventStatus === "PENDING") ||
            (res && res.custom_code === "ATTENDANCE_NOT_FOUND")
          ) {
            this.submitAttendance(userId, token);
          } else {
            this.$router.push("/validation-attendance-completed/already-given");
          }
        })
        .catch(() => {});
    },
    submitAttendance(userId, token) {
      this.$store
        .dispatch("users/postAttendance", {
          token: token,
          userId: userId,
        })
        .then((res) => {
          console.log(res);
          if (res && res.message === "Invalid User for Attendance Evaluation") {
            this.isUserReallyAssigned = true;
          } else if (
            res &&
            res.message === "Attendance Submitted Successfully"
          ) {
            localStorage.removeItem("attendanceValidationData");
            this.validationCompleted = true;
          } else if (res && res.message === "Attendance Already Submitted") {
            this.$router.push("/validation-attendance-completed/already-given");
          }
        })
        .catch(() => {});
    },
    altSrcImage(e) {
      return (e.target.src = `https://hostedboringavatars.vercel.app/api/beam?name=bauhaus`);
    },
  },
};
</script>

<style lang="scss" scoped>
$primary-color: #101828;
.redirect {
  &__heading {
    background: #f9e7ca;
    font-size: 2.5rem;
    color: $primary-color;
  }

  &__description {
    &__content {
      width: 81%;
      .tag {
        &__text {
          padding: 0.35em 0.75em;
          background: #f2f4f7;
          border-radius: 2em;
          color: $primary-color;
        }
      }
    }

    .course {
      &__content {
        .course-img {
          margin-right: 2em;
          width: 15%;
          overflow: hidden;
          height: 12em;
        }

        .details {
          width: 85%;

          &__title {
            margin-bottom: 0.85em;

            p {
              color: #344054;
            }
          }

          &__heading {
            width: 75%;
            margin-bottom: 0.85em;

            h4 {
              color: $primary-color;
            }
          }

          &__text {
            width: 75%;
          }

          &__logo {
            width: 1.5em;
          }
        }
      }
    }
  }

  .clip-text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    &-3 {
      -webkit-line-clamp: 3;
    }
  }
}

@media only screen and (max-width: 1200px) {
  .redirect {
    &__description {
      .course {
        &__content {
          .course-img {
            width: 30%;
            margin-right: 1.75em;

            &__logo {
              width: 2em;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .redirect {
    &__heading {
      font-size: 2em;
    }

    &__description {
      &__content {
        width: 100%;
        padding: 2em 0;

        p {
          font-size: 1em;
        }
      }

      .course {
        &__content {
          .course-img {
            width: 25%;
            margin-right: 1.75em;

            &__logo {
              width: 2em;
            }
          }

          .details {
            width: 70%;

            &__heading {
              width: 100%;
            }

            &__text {
              width: 100%;
            }

            &__logo {
              width: 1.25em;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 600px) {
  .redirect {
    &__heading {
      font-size: 1.5em;
    }

    &__description {
      .course {
        &__content {
          padding: 0;
          flex-direction: column;

          .course-img {
            width: 100%;

            &__logo {
              width: 1.75em;
            }
          }

          .details {
            width: 100%;

            &__logo {
              margin-right: 0.5em;
            }
          }
        }
      }
    }
  }
}
</style>
